import script from "./FileItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileItem.vue?vue&type=script&setup=true&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=5d305a1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d305a1a"]])

export default __exports__